import * as React from 'react';
import * as styles from './SearchResultsItem.css';

interface ISearchResultsItemProps extends React.PropsWithChildren {
  onClick?(): void;
}

export const SearchResultsItem: React.FC<ISearchResultsItemProps> = ({ children, onClick }) => {
  const handleKeyPress = React.useCallback(
    (event: React.KeyboardEvent) => {
      if (onClick && ['Enter', 'Space'].includes(event.code)) {
        onClick();
      }
    },
    [onClick],
  );

  return (
    <div onClick={onClick} onKeyPress={handleKeyPress} className={styles['container']} role="button" tabIndex={0}>
      <div className={styles['inner']}>{children}</div>
    </div>
  );
};
